import { Reducer } from 'redux';

// Actions

/** Change tick size to custom user tick size configured by Orderbook dropdown */
export const changeMarketTickSize = (
  market: string,
  tickSizeInDecimals: string
) => ({
  type: 'USER_TICK_SIZE_MARKET_UPDATE' as const,
  market,
  tickSizeInDecimals,
});

/** Wipe stored, When user tick size equal to market default tick size */
export const removeStoredMarketTickSize = (market: string) => ({
  type: 'USER_TICK_SIZE_MARKET_REMOVE' as const,
  market,
});

type userMarketsTickSizeActions = ReturnType<
  typeof changeMarketTickSize | typeof removeStoredMarketTickSize
>;

// Reducer

type UserMarketsTickSizeState = {
  [market: string]: string; // in decimal format 0.0000001
};

const defaultState: UserMarketsTickSizeState = {};

// @cached
export const userTickSizeReducer: Reducer<
  UserMarketsTickSizeState,
  userMarketsTickSizeActions
> = (state = defaultState, action): UserMarketsTickSizeState => {
  switch (action.type) {
    case 'USER_TICK_SIZE_MARKET_UPDATE':
      return {
        ...state,
        [action.market]: action.tickSizeInDecimals,
      };

    case 'USER_TICK_SIZE_MARKET_REMOVE': {
      const { [action.market]: _removed, ...newState } = state;
      return newState;
    }
    default:
      return state;
  }
};
